import HelpPortal from "@/pages/HelpPortal";
import ManageAccount from "../components/ManageAccountContributions";
import ForgotPassword from "../components/Auth/ForgotPassword";
import VerifyResetPassword from "../components/Auth/ForgotPassword/verifyResetPassword";
import PrivacyPolicy from "../components/Legal/PrivacyPolicy";
import Wizard from "../components/Wizard";
import CreatePassword from "../pages/CreatePassword";
import Home from "../pages/Home";
import SEPIntroduction from "../pages/Introduction";
import Login from "../pages/Login";
import ResetPassword from "../pages/ResetPassword";
import SavingsSettings from "../pages/SavingsSettings";

type RouteType = {
  path: string;
  element: React.ComponentType<any>;
  protected: boolean;
};

export const routes: RouteType[] = [
  { path: "/", element: Home, protected: true },
  { path: "/legal/privacy-policy", element: PrivacyPolicy, protected: false },
  { path: "/login", element: Login, protected: false },
  { path: "/create-password", element: CreatePassword, protected: false },
  { path: "/reset-password", element: ResetPassword, protected: true }, // remember to delete this route
  { path: "/forgot-password", element: ForgotPassword, protected: false },
  { path: "/verify-code", element: VerifyResetPassword, protected: false },
  { path: "/sep-introduction", element: SEPIntroduction, protected: false },
  { path: "/wizard", element: Wizard, protected: true },
  { path: "/manage-account/:id", element: ManageAccount, protected: true },
  { path: "/savings-settings", element: SavingsSettings, protected: true },
  { path: "/help", element: HelpPortal, protected: false },
];
